import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b23d9d58&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=b23d9d58&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=b23d9d58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23d9d58",
  null
  
)

export default component.exports